import { makeStyles } from "@material-ui/core";

import type { CoretexTheme } from "../../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  list: {
    "&::-webkit-scrollbar": {
      width: theme.spacing(2),
    },
    "&::-webkit-scrollbar-track": {
      borderRadius: theme.spacing(1),
      backgroundColor: "#FAFAFF",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.mono.mediumGray,
      borderRadius: theme.spacing(1),
    },
    scrollbarGutter: "stable",
  },
  listHover: {
    "&::-webkit-scrollbar": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
    },

    "&:hover": {
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: theme.palette.mono.mediumGray,
      },
    },
  },
}));

export default useStyles;
